import { RatelistType } from "@sinch/core/entities/serverEnums.types";
import React, { PropsWithChildren, useContext } from "react";

type RateBuilderSettingsContextValue = {
  mode?: "edit" | "view" | "override";
  rateType: RatelistType;
  disableConditions?: boolean;
  disableNesting?: boolean;
};
const RateBuilderSettingsContext = React.createContext<RateBuilderSettingsContextValue | undefined>(undefined);
RateBuilderSettingsContext.displayName = "RateBuilderSettings";

export const RateBuilderSettingsProvider = ({
  children,
  rateType,
  disableConditions,
  disableNesting,
  mode,
}: PropsWithChildren<RateBuilderSettingsContextValue>) => (
  <RateBuilderSettingsContext.Provider value={{ rateType, disableConditions, disableNesting, mode }}>
    {children}
  </RateBuilderSettingsContext.Provider>
);

export function useRateBuilderSettings(): RateBuilderSettingsContextValue {
  const context = useContext(RateBuilderSettingsContext);
  if (!context) {
    throw new Error("useRateBuilderSettings must be used as an RateBuilderSettingsContext");
  }
  return context;
}
